// Lib
import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';

// Selectors
import { selectIsMarkActive } from './selectors/tiptapToolSelectors';
import { selectIsMobileAppMode } from '../../../../../platform/platformSelector';

// Hooks
import {
    useActiveTiptapEditorCallback,
    useTiptapActiveEditorSelector,
} from '../../../../../components/tiptapEditor/store/tiptapEditorStoreHooks';

// Components
import RichTextTool from './RichTextTool';

// Types
import { ToolbarToolProps } from '../../../config/toolDefinitions/toolbarToolTypes';

type StandardTiptapMarkToolProps = ToolbarToolProps & {
    mark: string;
};

const TiptapToggleMarkTool = (props: StandardTiptapMarkToolProps): ReactElement => {
    const { mark } = props;

    const isActive = useTiptapActiveEditorSelector(selectIsMarkActive(mark));
    const isMobile = useSelector(selectIsMobileAppMode);

    const toggleMark = useActiveTiptapEditorCallback(
        (activeEditor, event) => {
            if (!activeEditor) return;

            event?.preventDefault();

            activeEditor.commands.toggleMark(mark);

            if (isMobile) activeEditor.view.focus();
        },
        [mark, isMobile],
    );

    return (
        <RichTextTool isActive={isActive} onClick={toggleMark} iconName={props.iconName || 'toolbar-bold'} {...props} />
    );
};

export default TiptapToggleMarkTool;
